module.exports = __webpack_public_path__ + "static/media/1009797.d308ea86.jpg";